import { EntityProvider, useEntity } from '@backstage/plugin-catalog-react';
import { EntityLinksCard } from '@backstage/plugin-catalog';
import { Entity, EntityLink } from '@backstage/catalog-model';

// A team's "Alerts & Notifications" slack link is notification metadata for
// background agents only — it must never render on the team page, unlike
// every other resource link (including the "Public" slack sub-type).
function isTeamPageVisible(link: EntityLink): boolean {
  return !(link.icon === 'slack' && link.type === 'alerts_notifications');
}

/**
 * Team-page resource links: same as {@link EntityLinksCard}, but filters out
 * the Alerts & Notifications slack link before rendering.
 */
export function EntityTeamLinksCard() {
  const { entity } = useEntity();
  const links = (entity.metadata.links ?? []).filter(isTeamPageVisible);

  const visibleEntity: Entity = {
    ...entity,
    metadata: { ...entity.metadata, links },
  };

  return (
    <EntityProvider entity={visibleEntity}>
      <EntityLinksCard />
    </EntityProvider>
  );
}
